import createReducer from '../createReducer'
import {
  SHOW_GENERIC_MESSAGE,
  HIDE_GENERIC_MESSAGE,
  SET_URL_REDIRECT
} from './constants'

const initialState = {
  urlRedirect: undefined,
  genericMessage: {
    visible: false,
    message: ''
  }
}

const reducer = createReducer(initialState, {
  [SHOW_GENERIC_MESSAGE]: (state, action) => ({
    ...state,
    genericMessage: {
      visible: true,
      message: action.payload
    }
  }),
  [HIDE_GENERIC_MESSAGE]: (state, action) => ({
    ...state,
    genericMessage: initialState.genericMessage
  }),
  [SET_URL_REDIRECT]: (state, action) => ({
    ...state,
    urlRedirect: action.payload
  })
})

export default reducer
